export const classBase = "saltFormFieldLegacy";
